module.exports = __webpack_public_path__ + "static/img/3bg_2.f5df721.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_2.png
// module id = 686
// module chunks = 1